module.exports = __webpack_public_path__ + "media/images/lightbox/next-938a4c662ff3743a09141f1fcdcde4d9.png";